import {Injectable} from '@angular/core';
import {WizardNestedFormService} from '../abstract/wizard-nested-form-service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {WizardEnums} from '../../../wizard.namespace';
import {WizardValidators} from '../../wizard-validators';
import {takeUntil} from 'rxjs/operators';
import {WizardFormEventsService} from '../wizard-form-events.service';

@Injectable()
export class LaboratoryOwnerService extends WizardNestedFormService {
    form = this.fb.group({
        _touched: [false, Validators.requiredTrue],

        leader_id: ['', WizardValidators.required('Руководитель лаборатории должен быть обязательно назначен.', false)],

        /**
         * Тип подчинения руководителя организации
         */
        slave_type: [WizardEnums.LaboratorySlaveTypes.organizationHead, WizardValidators.required()],

        owner: ['', [
            WizardValidators.required('Кому подчиняется руководитель лаборатории'),
            WizardValidators.withoutSymbols('имени специалиста'),
        ]],
        owner_job: ['', [
            WizardValidators.required('Должность руководителя, кому подчиняется руководитель лаборатории,'),
            WizardValidators.withoutSymbols('названии должности'),
        ]],
        owner_job_genitive: ['', [
            WizardValidators.required('Должность руководителя, кому подчиняется руководитель лаборатории,'),
            WizardValidators.withoutSymbols('названии должности'),
        ]],
        owner_job_dative: ['', [
            WizardValidators.required('Должность руководителя, кому подчиняется руководитель лаборатории,'),
            WizardValidators.withoutSymbols('названии должности'),
        ]],

        isSubleader: [false], // Предусмотрен заместитель?
        subleader_id: ['', [
            WizardValidators.required('Заместитель руководителя лаборатории должен быть обязательно указан, если он есть.', false),
        ]],
    });

    wizardForm: FormGroup;

    constructor(
        private fb: FormBuilder,
        private wizardFormEventsService: WizardFormEventsService,
    ) {
        super();
    }

    init() {
        this.form.get('slave_type').valueChanges.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((value) => {
            this.onSlaveTypeChange(value);
        });

        this.form.get('slave_type').patchValue(this.form.get('slave_type').value);

        this.form.get('isSubleader').valueChanges.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((value) => {
            this.onHasSubleaderChange(value);
        });

        this.form.get('isSubleader').patchValue(this.form.get('isSubleader').value);

        this.form.get('leader_id').valueChanges.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((id) => {
            this.wizardFormEventsService.setLaboratoryLeaderId(id);
        });

        this.form.get('leader_id').updateValueAndValidity();
    }

    private onSlaveTypeChange(type) {
        if (+type === WizardEnums.LaboratorySlaveTypes.custom) {
            this.form.get('owner').enable();
            this.form.get('owner_job').enable();
            this.form.get('owner_job_genitive').enable();
            this.form.get('owner_job_dative').enable();
        } else {
            this.form.get('owner').patchValue('');
            this.form.get('owner').disable();
            this.form.get('owner_job').patchValue('');
            this.form.get('owner_job').disable();
            this.form.get('owner_job_genitive').patchValue('');
            this.form.get('owner_job_genitive').disable();
            this.form.get('owner_job_dative').patchValue('');
            this.form.get('owner_job_dative').disable();
        }
    }

    private onHasSubleaderChange(value) {
        if (Boolean(value)) {
            this.form.get('subleader_id').enable();
        } else {
            this.form.get('subleader_id').disable();
            this.form.get('subleader_id').patchValue(null);
        }
    }
}
